import { render, staticRenderFns } from "./vertically-hideable-html.vue?vue&type=template&id=0a2dcb97&"
import script from "./vertically-hideable-html.vue?vue&type=script&lang=js&"
export * from "./vertically-hideable-html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2dcb97')) {
      api.createRecord('0a2dcb97', component.options)
    } else {
      api.reload('0a2dcb97', component.options)
    }
    module.hot.accept("./vertically-hideable-html.vue?vue&type=template&id=0a2dcb97&", function () {
      api.rerender('0a2dcb97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/vertically-hideable-html.vue"
export default component.exports